import { render, staticRenderFns } from "./FiltrosBorracharia.vue?vue&type=template&id=0802b3a6&"
import script from "./FiltrosBorracharia.vue?vue&type=script&lang=js&"
export * from "./FiltrosBorracharia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports